import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { OpportunityBackend } from '@libs/src/opportunity/opportunity.backend';

import { fadeInEnter } from '@libs/src/animations/animations';
import { Opportunity } from '@main-client/src/app/opportunity/opportunity.model';

@Component({
  animations: [fadeInEnter],
  selector: 'app-sign-up-event-banner',
  standalone: false,
  templateUrl: './sign-up-event-banner.component.html',
})
export class SignUpEventBannerComponent implements OnInit {
  @Input() opportunityId: string;
  error: string;
  opportunity: Opportunity;
  signupText: any = {};

  constructor(
    public datePipe: DatePipe,
    public opportunityBackend: OpportunityBackend,
  ) {}

  ngOnInit(): void {
    this.opportunityBackend.v3
      .getPublicOpportunity(this.opportunityId)
      .pipe(
        tap((opportunity: Opportunity) => {
          if (!opportunity) {
            this.error = `We can't find the Office Hour you're looking for, please make sure you have the right link.`;
            return;
          }
          this.opportunity = opportunity;
          this.signupText = {
            past: $localize`:@@eventsView.signupEventBanner.pastEventText:${this.opportunity?.title} has already passed. You can still join to get notified of any future Office Hours.`,
            upcoming: $localize`:@@eventsView.signupEventBanner.upcomingEventText:Join the community to register for "${
              this.opportunity?.title
            }" on ${this.datePipe.transform(
              this.opportunity?.event_start_date,
              'fullDate',
            )} at ${this.datePipe.transform(
              this.opportunity?.event_start_date,
              'shortTime',
            )}.`,
          };
        }),
        catchError((response: HttpErrorResponse) => {
          this.error = response?.error?.message || response?.error;
          return EMPTY;
        }),
      )
      .subscribe();
  }
}
